// External
import { Component, OnInit, Input, ElementRef, Renderer2, HostListener } from '@angular/core';

// Internal
export enum CardType {
    FLAT   = 'flat',
    RAISED = 'raised',
    CLEAR  = 'clear',
    EMPTY  = 'empty'
}
@Component({
    selector: 'ui-card',
    // templateUrl: './ui-card.component.html'
    template: `<ng-content select="card-header, [card-header]" #cardHeader></ng-content>
              <ng-content select="card-body, [card-body]" #cardBody></ng-content>
              <ng-content select="card-footer, [card-footer]" #cardFooter></ng-content>`,
    host: {
        '[attr.tabindex]': 'clickable ? 0 : "-1"',
        '[class.clickable-card]': 'clickable === true'
    }
})

export class UiCardComponent implements OnInit {

    @Input() type: CardType = CardType.FLAT; // flat / raised / clear / empty
    @Input() clickable = false;

    constructor(readonly renderer: Renderer2, readonly el: ElementRef) {}

    ngOnInit() {
        this.renderer.addClass(this.el.nativeElement, 'card');
        this.renderer.addClass(this.el.nativeElement, this.type);
    }

    // if click-able force click on enter
    @HostListener('keyup.enter', ['$event']) onEnter(event) {
        if(this.clickable){
            this.el.nativeElement.click();
        }
    }


}
